import { http } from "../framework/api";
import authService from "../framework/authService";
import storageService from "../services/storage-service";
import config from "../config";
import { AuthContext } from "../framework/auth";
import { checkSmsStatus } from "../actions/portal.action";

import {
  LOGIN,
  LOGIN_SUCCESSFUL,
  LOGIN_FAIL,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESSFUL,
  FORGOT_PASSWORD_FAIL,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_FAIL,
  USER_CAN_RESET_PASSWORD,
  USER_CAN_RESET_PASSWORD_SUCCESSFUL,
  USER_CAN_RESET_PASSWORD_FAIL,
  LOGOUT,
  LANGUAGE_CHANGED,
  POST_TIMEZONE_LOADING,
  POST_TIMEZONE_LOADING_SUCCESSFUL,
  POST_TIMEZONE_LOADING_FAIL,
} from "../reducers/account.reducer";

export const login = (username, password, stayLoggedIn = false) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: LOGIN,
      payload: null,
    });
    let url = `${config.API_ROOT_URL}/accounts/login`;
    let data = {
      username: username,
      password: password,
    };
    http("POST", url, data, false)
      .then(function (res) {
        var token = res.Token;
        authService.login(token, stayLoggedIn);

        storageService.setStorageItem(config.USER_ID, res.Id);
        storageService.setStorageItem(config.HAS_KIPPU_ACC_ID, res.HasKippuAccId ?? false);

        // Update AuthContext through a custom event
        window.dispatchEvent(
          new CustomEvent("authStateChanged", {
            detail: { isAuthenticated: true, token },
          }),
        );

        storageService.setStorageItem(config.TIMEZONE, res.TimeZone);
        if (storageService.getStorageItem(config.LANG) == null) {
          storageService.setStorageItem(config.LANG, res.Lang);
        }

        dispatch({
          type: LANGUAGE_CHANGED,
          payload:
            storageService.getStorageItem(config.LANG) != null
              ? storageService.getStorageItem(config.LANG)
              : res.Lang,
        });

        dispatch({
          type: LOGIN_SUCCESSFUL,
          payload: res,
        });

        storageService.setStorageItem(config.USERNAME, res.FirstName);

        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: LOGIN_FAIL,
          payload: res,
        });
        reject(res);
      });
  });
export const logoutUser = () => (dispatch) => {
  authService.logout();

  // Clear extended session on logout
  localStorage.removeItem(config.STAY_LOGGED_IN_UNTIL);
  storageService.setStorageItem(config.HAS_KIPPU_ACC_ID, false);

  // Update AuthContext through a custom event
  window.dispatchEvent(
    new CustomEvent("authStateChanged", {
      detail: { isAuthenticated: false },
    }),
  );

  dispatch({
    type: LOGOUT,
  });

  dispatch({
    type: LANGUAGE_CHANGED,
    payload: "",
  });
};

export const forgotPassword = (email) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: FORGOT_PASSWORD,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/accounts/forgot-password?username=${email}`;

    http("GET", url, null, false)
      .then(function (res) {
        dispatch({
          type: FORGOT_PASSWORD_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: FORGOT_PASSWORD_FAIL,
          payload: res,
        });
        reject(res);
      });
  });
export const resetPassword = (email, password, guid) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: RESET_PASSWORD,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/accounts/reset-password`;
    let data = {
      username: email,
      newPassword: password,
      resetGuid: guid,
    };
    http("POST", url, data, false)
      .then(function (res) {
        dispatch({
          type: RESET_PASSWORD_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: RESET_PASSWORD_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const canUserResetPassword = (email, guid) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: USER_CAN_RESET_PASSWORD,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/accounts/reset-password?email=${email}&guid=${guid}`;

    http("GET", url, null, false)
      .then(function (res) {
        dispatch({
          type: USER_CAN_RESET_PASSWORD_SUCCESSFUL,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: USER_CAN_RESET_PASSWORD_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const changeUserLang = (lang) => (dispatch) => {
  storageService.setStorageItem(config.LANG, lang);

  dispatch({
    type: LANGUAGE_CHANGED,
    payload: lang,
  });
};

export const postTimeZone = (id) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: POST_TIMEZONE_LOADING,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/accounts/mytimezone`;
    var data = { id: id };
    http("POST", url, data)
      .then(function (res) {
        dispatch({
          type: POST_TIMEZONE_LOADING_SUCCESSFUL,
          payload: res,
        });
        storageService.setStorageItem(config.TIMEZONE, id);
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: POST_TIMEZONE_LOADING_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const updateResponseStatus = (answerType) => (dispatch) =>
  new Promise((resolve, reject) => {
    let url = `${config.API_ROOT_URL}/accounts/updateResponseStatus`;
    let data = { answerType: answerType };

    http("POST", url, data)
      .then(function (res) {
        resolve(res);
      })
      .catch(function (res) {
        reject(res);
      });
  });